<div *ifScreenSize="screenType.Mobile">
  <router-outlet></router-outlet>
</div>
<div *ifScreenSize="screenType.Desktop">
  <fgb-not-found-page></fgb-not-found-page>
</div>
